export const isDev= process?.env.NODE_ENV === "development";
export let baseUrl= process.env.REACT_APP_IS_TEST ? "/lb" : "";
